<template>
  <div>
    <v-card class="shop-footer">
      <v-row>
        <v-col xl="4" lg="4" md="4" sm="12" xs="12" cols="12">
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <h5 class="shopDeeppurple--text mt-2 text-right">درباره ما:</h5>
          </v-col>
          <hr />
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <span class="fs-small mainFont--text">
              کتاب باز با مشورت اساتید و مشاورین به نام کشور؛ در تلاش است بهترین
              کتب و مناسب‌ترین قیمت‌ها را همراه با تخفیفات باور نکردنی در اختیار
              شما دانش آموزان عزیز قرار دهد.
            </span>
          </v-col>
          <v-row>
            <v-col xl="4" lg="4" md="4" sm="12" xs="12" cols="12">
              <div class="about-Us-img">
                <a
                  referrerpolicy="origin"
                  target="_blank"
                  href="https://trustseal.enamad.ir/?id=524408&Code=H3L8YkaCgt2qhGBwJgWfkbMkNVkPecrd"
                  ><img
                    referrerpolicy="origin"
                    src="https://trustseal.enamad.ir/logo.aspx?id=524408&Code=H3L8YkaCgt2qhGBwJgWfkbMkNVkPecrd"
                    alt=""
                    style="cursor: pointer"
                    code="H3L8YkaCgt2qhGBwJgWfkbMkNVkPecrd"
                /></a>
              </div>
            </v-col>
            <v-col xl="4" lg="4" md="4" sm="12" xs="12" cols="12">
              <div class="about-Us-img">
                <a
                  referrerpolicy="origin"
                  target="_blank"
                  href="https://eanjoman.ir/member/ChJdWrVQLZnZ76HWeG4e84Wv4"
                >
                  <img
                    src="https://eanjoman.ir/api/script?code=ChJdWrVQLZnZ76HWeG4e84Wv4"
                    alt="انجمن صنفی کارفرمایی فروشگاه های اینترنتی شهر تهران(کسب و کار های اینترنتی)"
                    title="انجمن صنفی کارفرمایی فروشگاه های اینترنتی شهر تهران(کسب و کار های اینترنتی)"
                  />
                </a>
              </div>
            </v-col>
            <v-col xl="4" lg="4" md="4" sm="12" xs="12" cols="12">
              <div class="about-Us-img">
                <a
                  referrerpolicy="origin"
                  target="_blank"
                  href="https://www.zarinpal.com/trustPage/ketabbaaz.com"
                >
                  <img
                    src="../../assets/images/zarinpal.svg"
                    alt="درگاه پرداخت امن زرین پال(لوگوی تاييد زرين پال)"
                    title="درگاه پرداخت امن زرین پال(لوگوی تاييد زرين پال)"
                  />
                </a>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col xl="4" lg="4" md="4" sm="12" xs="12" cols="12">
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <h5 class="shopDeeppurple--text mt-2 text-right">دسترسی سریع</h5>
          </v-col>
          <hr />
          <v-row>
            <v-col
              xl="3"
              lg="3"
              md="6"
              sm="3"
              xs="6"
              cols="6"
              align="center"
              v-for="item in images"
              :key="item.id"
            >
              <a :href="item.route">
                <img :src="item.src" :alt="item.id" class="img-footer" />
              </a>
            </v-col>
          </v-row>
        </v-col>
        <v-col xl="4" lg="4" md="4" sm="12" xs="12">
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <h5 class="shopDeeppurple--text mt-2 text-right">ارتباط با ما</h5>
          </v-col>
          <hr />
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <a href="tel:02166120447" class="mainFont--text line-contact-us">
              <div class="title-contact-us">
                <v-icon class="shopDeeppurple--text">mdi-phone</v-icon>
                <span class="ms-1">شماره تماس: </span>
              </div>
              <span> 02166120447(ساعت پاسخگویی 11 الی 19) </span>
            </a>
          </v-col>
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <a
              href="mailto:info@ketabbaaz.com"
              class="mainFont--text line-contact-us"
            >
              <div class="title-contact-us">
                <v-icon class="shopDeeppurple--text">$Email</v-icon>
                <span class="ms-1">ایمیل: </span>
              </div>
              <span> info@ketabbaaz.com </span>
            </a>
          </v-col>
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <div class="shopPrimary--text mt-1">
              <a
                href="https://www.instagram.com/ketabbaaz_com/"
                target="_blank"
                class="mainFont--text line-contact-us"
              >
                <div class="title-contact-us">
                  <v-icon class="shopDeeppurple--text">$Instagram</v-icon>
                  <span class="ms-1"> اینستاگرام: </span>
                </div>
                <span> ketabbaaz_com </span>
              </a>
            </div>
          </v-col>
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <div class="shopPrimary--text mt-1">
              <a
                href="https://t.me/ketabbaaz_com"
                target="_blank"
                class="mainFont--text line-contact-us"
              >
                <div class="title-contact-us">
                  <v-icon class="shopDeeppurple--text">$Telegram</v-icon>
                  <span class="ms-1">تلگرام:</span>
                </div>
                <span> https://t.me/ketabbaaz_com </span>
              </a>
            </div>
          </v-col>
          <v-col xl="12" lg="12" md="12" sm="12" xs="12" cols="12">
            <div class="shopPrimary--text mt-1">
              <a
                href="https://www.aparat.com/Ketabbaaz.ir"
                target="_blank"
                class="mainFont--text line-contact-us"
              >
                <div class="title-contact-us">
                  <img
                    src="@/assets/aparat.png"
                    alt="Aparat Icon"
                    style="width: 24px; height: 24px"
                  />
                  <span class="ms-1">آپارات:</span>
                </div>
                <span> https://www.aparat.com/Ketabbaaz.ir </span>
              </a>
            </div>
          </v-col>
        </v-col>
      </v-row>
    </v-card>
    <v-row class="mx-auto pa-3 pb-6" style="background-color: #ebebeb">
      <div class="mx-auto">
        <span class="mainFont--text fs-xsmall"
          >طراحی، توسعه و اجرای فروشگاه اینترنتی:</span
        >
        <a
          class="font-weight-bold shopPrimary--text fs-small"
          href="https://sarmadbs.com/"
          target="blank"
          >خدمات تجارت سرمد</a
        >
      </div>
    </v-row>
  </div>
</template>
<script>
import help from "../../assets/images/help.png";
import rule from "../../assets/images/rule.png";
import advice from "../../assets/images/advice.png";
import store from "../../assets/images/store.png";
export default {
  data() {
    return {
      images: [
        {
          src: advice,
          id: 1,
          route: "/academicAdvice",
        },
        {
          src: store,
          id: 2,
          route: "/store/all",
        },
        {
          src: help,
          id: 3,
          route: "/help",
        },
        {
          src: rule,
          id: 4,
          route: "/rules",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.shop-footer {
  padding: 25px;
  background-color: #fff;
  border-radius: 0 !important;
  box-shadow: none !important;
}
.line-contact-us {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 4px;
  :first-child {
    margin-top: 0 !important;
  }
}
.title-contact-us {
  display: flex;
  align-items: center;
  align-self: center;
  margin-top: 5px;
  .v-icon {
    margin-top: 0 !important;
    font-size: 20px !important;
    color: #6200ea;
  }
}

.about-Us-img {
  display: flex;
  width: 60px;
  height: 80px;
  margin-left: 13px !important;
  margin-top: 10px;
  a {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
}
.img-footer {
  width: 90%;
  height: 100%;
  @media only screen and (max-width: 1262px) {
    width: 50%;
    height: 100%;
  }
  @media only screen and (max-width: 1024px) {
    width: 60%;
    height: 100%;
  }
  @media only screen and (max-width: 700px) {
    width: 90%;
    height: 100%;
  }
  @media only screen and (max-width: 599px) {
    width: 40%;
    height: 100%;
  }
  @media only screen and (max-width: 450px) {
    width: 50%;
    height: 100%;
  }
}
</style>
